import { IGridServerSideDatasource, toQuery, IServerSideGetRowsParams } from '@samc/centricity-core';
import { AjaxHelper, IPaginatedList } from '@samc/common';
import { IPackageDocumentResponse } from './../Interfaces';

export class PackageDocumentsDataSource implements IGridServerSideDatasource {
  public pageSize: number = 500;
  public cacheSize: number = 500;
  public adhocFilter: string = '';
  private _rowCount: number = 0;
  private _packageId: string;
  private _queryParams: any = {};
  public _verificationToken!: string;

  public constructor(packageId: string, verificationToken: string, packageType: 'buy' | 'sell') {
    this._rowCount = 0;
    this._packageId = packageId;
    this._queryParams = { packageId: packageId, packageType: packageType };

    this._verificationToken = verificationToken;
  }

  public async getRows(params: IServerSideGetRowsParams) {
    try {
      const helper = new AjaxHelper('', this._verificationToken, null, null);
      const result = await helper.getData<IPaginatedList<IPackageDocumentResponse>>(`/packagedocument/documents/${this._packageId}`,
        { ...toQuery(params), ...this._queryParams });

      this._rowCount = result.fullCount;
      params.success({ rowData: result.items, rowCount: this._rowCount });
    } catch (err: any) {
      params.fail();
    }
  }
}